import {
  raiseSocialEmbed,
  initMobileSlider,
  editorsPickSliderInit,
  lazyLoadImages,
} from "./functions";

jQuery(document).ready(function () {
  let listing_posts_offset = 40;
  let author_posts_offset = 20;
  let trending_posts_offset = 20;
  let archive_posts_offset = 20;
  let query_object;

  function getAiSearchFormRootId(template) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(template, "text/html");
    let firstDiv = doc.querySelector("div");
    let aisrId = "";
    if (firstDiv) {
      aisrId = firstDiv.getAttribute("id");
    }

    return aisrId;
  }

  function setRandomColorForLabels(labels) {
    labels.each(function () {
      const colors = ["#98CA3C", "#36C6F4", "#84459A", "#ED1B68", "#F26821"];
      let randomIndex = Math.floor(Math.random() * colors.length);
      let tag_color = colors[randomIndex];
      $(this).css("background-color", tag_color);
    });
  }

  if (typeof queried_object !== "undefined") {
    // the variable is defined
    query_object = queried_object;
  }

  let i = 0;
  $(document).on("click", "#articles-loadmore", function (e) {
    i++;
    const loadMoreButton = $(this);
    let tag_color = "";
    if ($("#tag_color").length) {
      tag_color = $("#tag_color").val();
    }

    e.preventDefault();
    let data = `&action=load_posts&posts_offset=${JSON.stringify(
      listing_posts_offset
    )}&term_info=${JSON.stringify(
      query_object
    )}&tag_color=${tag_color}&click_nb=${i}`;

    $.ajax({
      type: "POST",
      dataType: "html",
      url: load_posts.ajaxurl,
      data: data,
      beforeSend: function (e) {
        loadMoreButton.addClass("button--loading");
      },
      success: function (res) {
        $(".more-articles-section").show();
        let template = res;

        if (template.endsWith("0")) {
          template = template.substring(0, template.length - 1);
          if (template.replace(/\s/g, "").length > 0) {
          }
          template = JSON.parse(template);
        }

        if (template?.posts > 0) {
          listing_posts_offset += 20;
          loadMoreButton.removeClass("button--loading");
          if (template?.posts == 20) {
            loadMoreButton.css("display", "block");
          } else {
            loadMoreButton.css("display", "none");
          }
        } else {
          loadMoreButton.css("display", "none");
          $("#articles-loadmoreJobs").css("display", "none");
        }

        if (template?.posts > 0) {
          const $template = $(template.template);
          $("#more-articles").append($template);
          if (i === 1) initMobileSlider();
          if (i == 2) editorsPickSliderInit();
          lazyLoadImages();
          const scrollOffset = $template.offset().top + 350;
          $("html, body").animate({ scrollTop: scrollOffset }, 500);

          const aisrId = getAiSearchFormRootId(template.template);
          setTimeout(() => {
            raiseSocialEmbed();
          }, 100);
          if (window.initReact && aisrId.includes("aisearch_form"))
            window.initReact(aisrId);
        }
      },
    });
  });

  let authorClicks = 0;
  $("#author-loadmore").on("click", function (e) {
    e.preventDefault();
    authorClicks++;

    if (authorClicks == 1) author_posts_offset = 21;

    let data = `&action=load_posts&&posts_offset=${JSON.stringify(
      author_posts_offset
    )}&is_author=true&author_id=${JSON.stringify($("#author_id").val())}`;

    $.ajax({
      type: "POST",
      dataType: "html",
      url: load_posts.ajaxurl,
      data: data,
      beforeSend: function (e) {
        $("#author-loadmore").addClass("button--loading");
      },
      success: function (res) {
        let template = res;

        if (template.endsWith("0")) {
          template = template.substring(0, template.length - 1);
          if (template.replace(/\s/g, "").length > 0) {
          }
          template = JSON.parse(template);
        }

        if (template?.posts > 0) {
          author_posts_offset += 20;
          $("#author-loadmore").removeClass("button--loading");
          if (template?.posts == 20) {
            $("#author-loadmore").css("display", "block");
          } else {
            $("#author-loadmore").css("display", "none");
          }
        } else {
          $("#author-loadmore").css("display", "none");
        }
        if (template?.posts > 0) {
          $("#author-articles-grid").append(template.template);

          let authorLabels = $("#author-articles-grid .article--small .label");
          const aisrId = getAiSearchFormRootId(template.template);

          setTimeout(() => {
            raiseSocialEmbed();
          }, 100);

          setRandomColorForLabels(authorLabels);
          if (window.initReact && aisrId.includes("aisearch_form"))
            window.initReact(aisrId);
        }
      },
    });
  });

  let movies_load_clicks = 0;
  $("#archive-loadmore").on("click", function (e) {
    e.preventDefault();

    movies_load_clicks++;

    let data = `&action=load_posts&posts_offset=${JSON.stringify(
      archive_posts_offset
    )}&post_type=${$("#post_type").val()}&term_info=${JSON.stringify(
      query_object
    )}`;

    let offset = 20;
    if ($("#post_type").val() == "movie" || query_object.taxonomy == "cinema") {
      if (movies_load_clicks > 1) {
        offset = 18;
      } else {
        offset = 17;
      }
    }

    $.ajax({
      type: "POST",
      dataType: "html",
      url: load_posts.ajaxurl,
      data: data,
      beforeSend: function (e) {
        $("#archive-loadmore").addClass("button--loading");
      },
      success: function (res) {
        let template = res;

        if (template.endsWith("0")) {
          template = template.substring(0, template.length - 1);
          if (template.replace(/\s/g, "").length > 0) {
          }
          template = JSON.parse(template);
        }

        if (template?.posts > 0) {
          archive_posts_offset += offset;
          $("#archive-loadmore").removeClass("button--loading");
          if (template?.posts == offset) {
            $("#archive-loadmore").css("display", "block");
          } else {
            $("#archive-loadmore").css("display", "none");
          }
        } else {
          $("#archive-loadmore").css("display", "none");
        }

        if (template?.posts > 0) {
          if ($(".post-type-archive-directory").length > 0) {
            $(".section--archive")
              .last()
              .after(
                '<section class="section section--archive">' +
                  template.template +
                  "</section>"
              );
          } else {
            $("#archive-articles-grid").append(template.template);
          }

          const aisrId = getAiSearchFormRootId(template.template);

          let archiveLabels = $(
            "#archive-articles-grid .article--small .label"
          );

          setRandomColorForLabels(archiveLabels);
          setTimeout(() => {
            raiseSocialEmbed();
          }, 100);
          if (window.initReact && aisrId.includes("aisearch_form"))
            window.initReact(aisrId);
        }
      },
    });
  });

  $("#trending-loadmore").on("click", function (e) {
    e.preventDefault();

    let data = `&action=load_posts&&posts_offset=${JSON.stringify(
      trending_posts_offset
    )}`;

    $.ajax({
      type: "POST",
      dataType: "html",
      url: load_posts.ajaxurl,
      data: data,
      beforeSend: function (e) {
        $("#trending-loadmore").addClass("button--loading");
      },
      success: function (res) {
        let template = res;

        if (template.endsWith("0")) {
          template = template.substring(0, template.length - 1);
          if (template.replace(/\s/g, "").length > 0) {
          }
          template = JSON.parse(template);
        }

        if (template?.posts > 0) {
          trending_posts_offset += 20;
          $("#trending-loadmore").removeClass("button--loading");
          if (template?.posts == 20) {
            $("#trending-loadmore").css("display", "block");
          } else {
            $("#trending-loadmore").css("display", "none");
          }
        } else {
          $("#trending-loadmore").css("display", "none");
        }
        if (template?.posts > 0) {
          $("#trending-articles-grid").append(template.template);

          let trendingLabels = $(
            "#trending-articles-grid .article--small .label"
          );

          const aisrId = getAiSearchFormRootId(template.template);

          setTimeout(() => {
            raiseSocialEmbed();
          }, 100);

          setRandomColorForLabels(trendingLabels);

          if (window.initReact && aisrId.includes("aisearch_form"))
            window.initReact(aisrId);
        }
      },
    });
  });

  $("#ThingsToDo-loadmore").on("click", function (e) {
    e.preventDefault();

    let tag_color = "";
    if ($("#tag_color").length) {
      tag_color = $("#tag_color").val();
    }

    let data = `&action=load_ThingsToDo_posts&posts_offset=${JSON.stringify(
      trending_posts_offset
    )}&tag_color=${tag_color}`;

    $.ajax({
      type: "POST",
      dataType: "html",
      url: load_ThingsToDo_posts.ajaxurl,
      data: data,
      beforeSend: function (e) {
        $("#ThingsToDo-loadmore").addClass("button--loading");
      },
      success: function (res) {
        let template = res;

        if (template.endsWith("0")) {
          template = template.substring(0, template.length - 1);
          if (template.replace(/\s/g, "").length > 0) {
          }
          template = JSON.parse(template);
        }

        if (template?.posts > 0) {
          trending_posts_offset += 20;
          $("#ThingsToDo-loadmore").removeClass("button--loading");
          if (template?.posts == 20) {
            $("#ThingsToDo-loadmore").css("display", "block");
          } else {
            $("#ThingsToDo-loadmore").css("display", "none");
          }
        } else {
          $("#ThingsToDo-loadmore").css("display", "none");
        }
        if (template?.posts > 0) {
          $("#ThingsToDo-articles-grid").append(template.template);

          const aisrId = getAiSearchFormRootId(template.template);

          if (window.initReact && aisrId.includes("aisearch_form"))
            window.initReact(aisrId);
        }
      },
    });
  });
});
